import { datajs, datajsAll } from '../shared/utils';

(function() {
	const initGoogleCalendarEvents = () => {
		const calendars = datajsAll('google-calendar');

		const setupGoogleCalendar = function(calendar) {
			const gridViewToggle = datajs('toggle-grid-view', calendar);
			const listViewToggle = datajs('toggle-list-view', calendar);
			const gridView = datajs('grid-view', calendar);
			const listView = datajs('list-view', calendar);

			if (gridViewToggle && gridViewToggle.length) {
				gridViewToggle[0].addEventListener('click', function() {
					listViewToggle[0].classList.remove('is-active');
					listView[0].classList.add('d-none');
					gridViewToggle[0].classList.add('is-active');
					gridView[0].classList.remove('d-none');
				});
			}

			if (listViewToggle && listViewToggle.length) {
				listViewToggle[0].addEventListener('click', function() {
					gridViewToggle[0].classList.remove('is-active');
					gridView[0].classList.add('d-none');
					listViewToggle[0].classList.add('is-active');
					listView[0].classList.remove('d-none');
				});
			}
		};

		if (calendars && calendars.length) {
			Array.from(calendars).forEach(function(calendar) {
				setupGoogleCalendar(calendar);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', initGoogleCalendarEvents);
})();
